import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ViewContainersService, UpdateComponentStoreService, ComponentConfig, BaseComponentConfig } from '@urbannex/view-containers';
import { baseMenuItems, crmOptions } from './configoptions';

@Component({
  selector: 'ngx-customers',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent extends BaseComponentConfig implements OnInit{
  /* MENU_ITEMS:NbMenuItem[] = baseMenuItems;
  headerTitle:string = "CRM";
  path:string = "crm";
  menuTag:string = "partyMenu"
  menuAndTitleOptions = {path:this.path,menuItems:this.MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag}; */
  
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    //console.log(configurationService.getProductStoreId())
    this.componentConfig = new ComponentConfig(crmOptions);
    
    }

    ngOnInit(): void {
      //this.viewContainerService.menuAndTitleOptions$.next(this.menuAndTitleOptions);
      setTimeout(() => {
        //console.log(this.configurationService.getProductStoreId());
        //this.componentConfig = new ComponentConfig(crmOptions);
        //this.componentConfig.listForm.findParameters["productStoreId"]=this.configurationService.getProductStoreId();
        
      }, 1);

      this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
      
    }
}  

